import React from "react";
import { FormattedMessage } from "react-intl";

import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";

export function CorrectionStageInput({
  maxValue,
  defaultValue,
  onChange,
}: {
  maxValue: number;
  defaultValue: number;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}) {
  return (
    <div id="correction-stage-section" className="form-group">
      <Label id="validation-stage" htmlFor="correction-stage-value" required>
        <FormattedMessage id="plan.cancel.stage" />
      </Label>

      <br />
      <Input
        id="correction-stage-value"
        type="number"
        size={2}
        min={1}
        max={maxValue}
        className="tw-inline tw-max-w-[80px]"
        name="stage"
        defaultValue={defaultValue}
        onInput={onChange}
      />
      <span>
        {" "}
        <FormattedMessage id="pat_table.of" /> {maxValue}
      </span>
    </div>
  );
}
